import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

export type MetricType = "memory" | "cpu";

interface MetricTypeProps {
  value: MetricType;
  onChange: (value: MetricType) => void;
}

const MetricTypeSelector = ({ value, onChange }: MetricTypeProps) => (
  <FormControl>
    <InputLabel size="small">Metric Type</InputLabel>
    <Select
      size="small"
      value={value}
      label="Metric Type"
      onChange={(e) => {
        onChange(e.target.value as MetricType);
      }}
      sx={{
        width: 124,
      }}
    >
      <MenuItem value="memory">Memory</MenuItem>
      <MenuItem value="cpu">CPU</MenuItem>
    </Select>
  </FormControl>
);

export default MetricTypeSelector;
